module.exports = __webpack_public_path__ + "img/flat-blank.eab445b7.jpg";